import { TextField } from "@mui/material";

import { Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import { Dispatch, SetStateAction } from "react";

function DateTimeLoc({
  modalMode,
  registerDate,
  setRegisterDate,
  registerStartTime,
  setRegisterStartTime,
  registerField,
  setRegisterField,
  disbaleTime,
  registerEndDate,
  setRegisterEndDate,
}: {
  modalMode: string;
  registerDate: string;
  setRegisterDate: Dispatch<SetStateAction<string>>;
  registerStartTime: Dayjs | null;
  setRegisterStartTime: Dispatch<SetStateAction<Dayjs | null>>;
  registerField: string;
  setRegisterField: Dispatch<SetStateAction<string>> | null;
  disbaleTime: boolean;
  registerEndDate?: string;
  setRegisterEndDate?: Dispatch<SetStateAction<string>>;
}) {
  return (
    <Stack spacing={2}>
      <Typography id="tournament-creation" variant="h6" component="h2">
        {modalMode}
      </Typography>
      <DatePicker
        data-testid="tournament-date"
        label={setRegisterEndDate ? "Event Start Date" : "Event Date"}
        value={registerDate ? dayjs(registerDate) : null}
        onChange={(event: Dayjs | null) => {
          if (event) {
            setRegisterDate(moment(event["$d"]).format("YYYY-MM-DD"));
          }
        }}
      />
      {setRegisterEndDate && (
        <DatePicker
          data-testid="tournament-date"
          label="Event End Date"
          value={registerEndDate ? dayjs(registerEndDate) : null}
          onChange={(event: Dayjs | null) => {
            if (event) {
              setRegisterEndDate(moment(event["$d"]).format("YYYY-MM-DD"));
            }
          }}
        />
      )}
      {!disbaleTime && (
        <TimePicker
          data-testid="lesson-time"
          label="Set Start Time"
          value={registerStartTime}
          onChange={(event: Dayjs | null) => {
            setRegisterStartTime(event);
          }}
        />
      )}
      {setRegisterField && (
      <TextField
        data-testid="tournament-field-name"
        id="field-name"
        label="Field Name"
        value={registerField}
        //variant="filled"
        onChange={(event: any) => {
            setRegisterField(event.target.value);
          }}
        />
      )}
    </Stack>
  );
}

export default DateTimeLoc;
